import { render, staticRenderFns } from "./shapePriceTypeDialog.vue?vue&type=template&id=2872e046&"
import script from "./shapePriceTypeDialog.vue?vue&type=script&lang=js&"
export * from "./shapePriceTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports